import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=56f8060c&scoped=true&"
import script from "./collect.vue?vue&type=script&lang=ts&"
export * from "./collect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f8060c",
  null
  
)

export default component.exports